import React from 'react';
import {
  SalesforceDealField,
  SalesforceDeal,
  useUpdateSalesforceDealFieldValueMutation,
} from 'api';

interface Props {
  salesforceDeal: SalesforceDeal;
  field: SalesforceDealField;
}

const TextFieldValue = ({salesforceDeal, field}: Props) => {
  const value = salesforceDeal.addition[`${field.fieldName}`];
  const [errorMessage, setErrorMessage] = React.useState('');
  const [updateFieldValue] = useUpdateSalesforceDealFieldValueMutation({
    onCompleted: (data) => {
      setErrorMessage(data.updateSalesforceDealFieldValue.error);
    },
  });

  return (
    <>
      <input
        name={field.label}
        defaultValue={value}
        onBlur={(e) =>
          updateFieldValue({
            variables: {
              salesforceDealId: salesforceDeal.id,
              attributes: {
                fieldName: field.fieldName,
                value: e.target.value,
              },
            },
          })
        }
      />
      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    </>
  );
};

export default TextFieldValue;
